import React from "react";

import { FaTwitter, FaFacebook, FaInstagram, FaPhone } from "react-icons/fa";
import "../styles/footer.scss";

const Footer = () => {
  return (
    <div className="footer-container">
      <footer className="footer">
        <div className="footer-logo">
          <div className="footer-logo-icontainer">
            <img src={require("../assets/images/res-logo.png")} alt="logo" />
          </div>
        </div>
        <div className="footer-content">
          <div className="footer-social-media">
            <span className="footer-media-text">Follow Us On</span>
            <ul className="footer-social-media-list">
              <li>
                <a href="#" className="footer-media-link">
                  <FaTwitter />
                </a>
              </li>
              <li>
                <a href="#" className="footer-media-link">
                  <FaFacebook />
                </a>
              </li>
              <li>
                <a href="#" className="footer-media-link">
                  <FaInstagram />
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-contact-info">
            <div className="footer-contact-number">
              <span className="footer-contact-icon">
                <FaPhone />
              </span>
              <a href="tel:+12894011359" className="footer-contact-link">
                Call us at +1(289)-401-1359
              </a>
            </div>
            <div className="footer-location">
              <div className="footer-location-text">
                <span>Address</span>
              </div>
              <address>
                Unit 2, 30 Rambler drive Brampton, ON L6W1E2 Canada
              </address>
            </div>
            <div className="footer-copyright">
              <span>&#169;</span>
              <span>Deccan Express. All Rights Reserved</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
